// extracted by mini-css-extract-plugin
export var container = "_hh-0";
export var content = "_hh-3";
export var customerTitle = "_hh-4";
export var empty = "_hh-5";
export var gray = "_hh-6";
export var header = "_hh-7";
export var info = "_hh-8";
export var loading = "_hh-2";
export var loadingCard = "_hh-9";
export var oneLine = "_hh-a";
export var personName = "_hh-e";
export var pillContainer = "_hh-b";
export var selected = "_hh-1";
export var text = "_hh-c";
export var twoLines = "_hh-d";
export var unread = "_hh-f";
export var unreadIndicator = "_hh-g";